import PatchController from '../PatchController';

export default class MySuccessController extends PatchController {
	public handle() {
		this.redirect(this.routes.mySuccess.indexRoute.href);
	}
}
